import * as types from '../mutation-types'
import { PersonApi, UserApi } from '@chirhos/chirhos-api'
import { ChiRhos } from '../../../'

export const state = {
  initialized: false,
  profile: null,
  access: null,
  // test: null,
}

// Example:
// https://gist.github.com/brianboyko/91fdfb492071e743e389d84eee002342#getters

// const getters = {
//   partnersList: state => state.partnersList, // gets the partner list.
//   // returns a function which returns any partner by id.
//   getPartnerById: (state) => (id) => state.partnersList[id],
//   // gets the current partner id.
//   currentPartnerId: state => state.currentPartnerId,
//   // gets the current partner object
//   // (even though that object isn't stored directly in the state)
//   currentPartner: state => state.partnersList[state.currentPartnerId],
// };

// Getters should not mutate data. (indeed, the purpose of a getter is to provide a "safer" way to access the vuex store values).
// They should only return the data you need.

// Getters are great for taking the data from the store then formatting it the way you need it before handing it off to the Vue component.
// This keeps transformation logic outside of the presentational Vue component. You can also use this pattern to create different transforms
// on the same data without mutating that data.

export const getters = {
  hasProfile(state) {
    if (!state.profile) return false
    if (!state.profile.entityId) return false
    return !!state.profile
  },
  // isNewUser(state) {},
  // isActive(state) {},
  isChiRhosOwner(state) {
    if (!state.access) return false
    return state.access.isChiRhosOwner
  },
  isTenantOwner(state) {
    let _chirhosConfig = getSavedState('chirhos.config')
    if (!_chirhosConfig) return false
    if (!_chirhosConfig.apiUrl) return false
    let _matches = _chirhosConfig.apiUrl.match(
      // eslint-disable-next-line no-useless-escape
      /^https?\:\/\/([^\/:?#]+)(?:[\/:?#]|$)/i
    )
    let _tenantHost = _matches && _matches[1]
    if (!_tenantHost) return false
    if (!state.profile) return false
    if (!state.profile.entityId) return false
    if (!state.access) return false
    if (!state.access.personStatusByTenant) return false
    let _tenantHostSettings = state.access.personStatusByTenant.filter(
      (obj) => {
        return obj.tenant === _tenantHost
      }
    )
    if (!_tenantHostSettings && _tenantHostSettings[0]) return false
    var _tenantHostStatus = _tenantHostSettings[0].status
    if (_tenantHostStatus.personEntityId !== state.profile.entityId)
      return false
    return _tenantHostStatus.isTenantOwner
  },
  isTenantAdmin(state) {
    let _chirhosConfig = getSavedState('chirhos.config')
    if (!_chirhosConfig) return false
    if (!_chirhosConfig.apiUrl) return false
    let _matches = _chirhosConfig.apiUrl.match(
      // eslint-disable-next-line no-useless-escape
      /^https?\:\/\/([^\/:?#]+)(?:[\/:?#]|$)/i
    )
    let _tenantHost = _matches && _matches[1]
    if (!_tenantHost) return false
    if (!state.profile) return false
    if (!state.profile.entityId) return false
    if (!state.access) return false
    if (!state.access.personStatusByTenant) return false
    let _tenantHostSettings = state.access.personStatusByTenant.filter(
      (obj) => {
        return obj.tenant === _tenantHost
      }
    )
    if (!_tenantHostSettings && _tenantHostSettings[0]) return false
    var _tenantHostStatus = _tenantHostSettings[0].status
    if (_tenantHostStatus.personEntityId !== state.profile.entityId)
      return false
    return _tenantHostStatus.isTenantAdmin
  },
}

export const mutations = {
  [types.INITIALIZE](state) {
    state.initialized = true
  },
  [types.SET_PROFILE](state, newProfile) {
    state.profile = newProfile
  },
  [types.SET_ACCESS](state, newAccess) {
    state.access = newAccess
  },
  // SET_TEST(state, newValue) {
  //   state.test = newValue
  // },
}

export const actions = {
  initialize({ commit, dispatch /* state */ }) {
    return dispatch('getProfile').then(() => {
      commit('user/' + types.INITIALIZE, null, {
        root: true,
      })
    })
  },
  saveProfile({ commit /* state */ }, person) {
    let ChiRhosApi = new ChiRhos().api()
    var personApi = new PersonApi(ChiRhosApi)

    personApi.Save(person).then(
      function(response) {
        if (
          response &&
          response.isOk &&
          response.data &&
          response.data.entity
        ) {
          commit('user/' + types.SET_PROFILE, response.data.entity, {
            root: true,
          })
        }
      },
      function(error) {
        console.error(error)
        commit('user/' + types.SET_PROFILE, null, {
          root: true,
        })
        commit('user/' + types.SET_ACCESS, null, {
          root: true,
        })
      }
    )
  },
  getProfile({ commit, state /*, rootState */ }, callback) {
    // 1. Check if we already have the profile as a current profile.
    const { profile } = state
    if (profile && profile.entityId) {
      return Promise.resolve(profile)
    }
    // 2. Fetch the profile from the API and cache it in case
    let ChiRhosApi = new ChiRhos().api()
    var personApi = new PersonApi(ChiRhosApi)
    var userApi = new UserApi(ChiRhosApi)

    var _return = Promise.all([personApi.GetSelf(), userApi.GetSelf()])
      .then(([personResponse, userResponse]) => {
        if (
          personResponse &&
          personResponse.isOk &&
          personResponse.data &&
          personResponse.data.entity
        ) {
          commit(types.SET_PROFILE, personResponse.data.entity)
        }

        if (
          userResponse &&
          userResponse.isOk &&
          userResponse.data &&
          userResponse.data.entity
        ) {
          commit(types.SET_ACCESS, {
            isChiRhosOwner: userResponse.data.entity.isChiRhosOwner,
            personStatusByTenant: userResponse.data.entity.personStatusByTenant,
            userId: userResponse.data.entity.userId,
          })
        }

        if (callback) {
          if (personResponse && userResponse) {
            callback()
          }
        }
        if (personResponse && userResponse) {
          return Promise.resolve(personResponse.data)
        }
      })
      .catch((/* error */) => {
        if (callback) {
          callback()
        }
      })

    return Promise.resolve(_return)
  },
  // fetchUser({ commit, state, rootState }, { username }) {
  //   // 1. Check if we already have the user as a current user.
  //   console.log(rootState.auth)
  //   const { currentUser } = rootState.auth
  //   if (currentUser && currentUser.username === username) {
  //     return Promise.resolve(currentUser)
  //   }
  //   // 2. Check if we've already fetched and cached the user.
  //   const matchedUser = state.profile.find((user) => user.username === username)
  //   if (matchedUser) {
  //     return Promise.resolve(currentUser)
  //   }
  //   // 3. Fetch the user from the API and cache it in case
  //   //    we need it again in the future.
  //   // return axios.get(`/user/${username}`).then(response => {
  //   //   const user = response.data
  //   //   commit('CACHE_PROFILE', user)
  //   //   return user
  //   // })
  // },
}

// https://gist.github.com/brianboyko/91fdfb492071e743e389d84eee002342#in-review

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

// function saveState(key, state) {
//   window.localStorage.setItem(key, JSON.stringify(state))
// }
